"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCounterOfferDto = instanceOfCounterOfferDto;
exports.CounterOfferDtoFromJSON = CounterOfferDtoFromJSON;
exports.CounterOfferDtoFromJSONTyped = CounterOfferDtoFromJSONTyped;
exports.CounterOfferDtoToJSON = CounterOfferDtoToJSON;
exports.CounterOfferDtoToJSONTyped = CounterOfferDtoToJSONTyped;
/**
 * Check if a given object implements the CounterOfferDto interface.
 */
function instanceOfCounterOfferDto(value) {
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    return true;
}
function CounterOfferDtoFromJSON(json) {
    return CounterOfferDtoFromJSONTyped(json, false);
}
function CounterOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'offerPrice': json['offerPrice'],
        'parentOfferId': json['parentOfferId'] == null ? undefined : json['parentOfferId'],
    };
}
function CounterOfferDtoToJSON(json) {
    return CounterOfferDtoToJSONTyped(json, false);
}
function CounterOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'offerPrice': value['offerPrice'],
        'parentOfferId': value['parentOfferId'],
    };
}
